/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  SAVE_ATTACHMENTS,
  SAVE_ATTACHMENTS_FAILURE,
  SAVE_ATTACHMENTS_SUCCESS,
  GET_ATTACHMENTS,
  GET_ATTACHMENTS_SUCCESS,
  GET_ATTACHMENTS_FAILURE,
  GET_ATTACHMENT_URL,
  GET_ATTACHMENT_URL_SUCCESS,
  GET_ATTACHMENT_URL_FAILURE,
  DELETE_ATTACHMENT,
  DELETE_ATTACHMENT_SUCCESS,
  DELETE_ATTACHMENT_FAILURE,
  ADD_ATTACHMENT_TAGS,
  ADD_ATTACHMENT_TAGS_FAILURE,
  ADD_ATTACHMENT_TAGS_SUCCESS,
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse,
} from "./reducerUtils";

const initialState = {
  files: [],
  attachments: {
    data: [],
    state: "INIT",
    error: null,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SAVE_ATTACHMENTS:
      return setLoadingState(state, "attachments", "SAVE");
    case SAVE_ATTACHMENTS_SUCCESS:
      return setSuccessResponse(state, action, "attachments", "SAVE");
    case SAVE_ATTACHMENTS_FAILURE:
      return setErrorResponse(state, action.err, "attachments", "SAVE");

    case GET_ATTACHMENTS:
      return setLoadingState(state, "attachments", "GET");

    case GET_ATTACHMENTS_SUCCESS:
      return setSuccessResponse(state, action, "attachments", "GET");
    case GET_ATTACHMENTS_FAILURE:
      return setErrorResponse(state, action.err, "attachments", "GET");
    case GET_ATTACHMENT_URL:
      return setLoadingState(state, "attachments", "GET_URL");

    case GET_ATTACHMENT_URL_SUCCESS:
      return setSuccessResponse(state, action, "attachments", "GET_URL");
    case GET_ATTACHMENT_URL_FAILURE:
      return setErrorResponse(state, action.err, "attachments", "GET_URL");
    case DELETE_ATTACHMENT:
      return setLoadingState(state, "attachments", "DELETE");

    case DELETE_ATTACHMENT_SUCCESS:
      return setSuccessResponse(state, action, "attachments", "DELETE");

    case DELETE_ATTACHMENT_FAILURE:
      return setErrorResponse(state, action.err, "attachments", "DELETE");
    case ADD_ATTACHMENT_TAGS:
      return setLoadingState(state, "attachments", "ADD_TAGS");

    case ADD_ATTACHMENT_TAGS_SUCCESS:
      return setSuccessResponse(state, action, "attachments", "ADD_TAGS");
    case ADD_ATTACHMENT_TAGS_FAILURE:
      return setErrorResponse(state, action.err, "attachments", "ADD_TAGS");
    default:
      return state;
  }
}
